module.exports = require("q");


//////////////////
// WEBPACK FOOTER
// external "q"
// module id = 101
// module chunks = 0